namespace SPA
{
	export namespace Guide
	{
		export class GuideRoot extends ui.base.BaseHTMLElement
		{

			private m_GuidePanel: GuidePanel;
			private m_GuideContent: ui.base.BaseHTMLElement;
			private m_GuideNavigation: ui.base.BaseHTMLElement;
			private m_StartIndex: number;

			public constructor( start_index?: number )
			{
				super( 'guide-root' );

				this.m_GuideContent			= new ui.base.BaseHTMLElement( 'guide-content-panel' );
				this.m_GuideNavigation	= new ui.base.BaseHTMLElement( 'guide-navigation' );
				this.m_GuidePanel				= new GuidePanel( this.m_GuideContent );

				this.m_StartIndex				= start_index || 0;

				this.css(
					{
						margin: '5px'
					}
				);
			}

			public rebuild( root: ui.base.BaseHTMLElement ): GuideRoot
			{
				this.empty();
				this.remove();

				this.appendTo( root );

				this.m_GuidePanel.rebuild( this );
				this.m_GuideContent.appendTo( this );

				if ( !this.m_GuidePanel.moveTo( ( this.m_StartIndex >= 0 ) ? this.m_StartIndex : 0 ) )
				{
					this.m_StartIndex = 0;

					this.m_GuidePanel.moveTo( 0 );
				}

				return this;
			}

			public addItem( item: GuideItem ): GuideRoot
			{
				this.m_GuidePanel.addItem( item );

				return this;
			}

		}
	}
}
